import { IInvoices } from 'modules/_common/models';
import API from 'services/api';

export const getInvoices = ({ id }: { id: string | null }): Promise<IInvoices[]> =>
  API.get(`/api/accommodation/calculations/${id}/invoices`)?.then(response => response?.data);
